import { PERSONAL_SKILL_STATUS_IN_MEETING_PREPARATION, EMPLOYEE_SKILL_STATUS_IN_MEETING, SKILL_STATUS_BLOCKS_MEETING } from './Queries'
import { useQuery, QueryResult } from '@apollo/client'
import {
  GetPersonalSkillStatusInEmployeePreparationQuery,
  GetPersonalSkillStatusInEmployeePreparationQueryVariables,
  GetEmployeeSkillStatusInMeetingQuery,
  GetEmployeeSkillStatusInMeetingQueryVariables,
  SkillStatusBlocksMeetingQuery,
  SkillStatusBlocksMeetingQueryVariables,
} from '../../types'

export const usePersonalSkillStatusInMeetingPreparation = (
  employeeId: string,
): QueryResult<GetPersonalSkillStatusInEmployeePreparationQuery, GetPersonalSkillStatusInEmployeePreparationQueryVariables> => {
  return useQuery<GetPersonalSkillStatusInEmployeePreparationQuery, GetPersonalSkillStatusInEmployeePreparationQueryVariables>(
    PERSONAL_SKILL_STATUS_IN_MEETING_PREPARATION,
    {
      variables: { id: employeeId },
      fetchPolicy: 'network-only',
    },
  )
}

export const useEmployeeSkillStatusInMeeting = (
  employeeId: string,
): QueryResult<GetEmployeeSkillStatusInMeetingQuery, GetEmployeeSkillStatusInMeetingQueryVariables> => {
  return useQuery<GetEmployeeSkillStatusInMeetingQuery, GetEmployeeSkillStatusInMeetingQueryVariables>(EMPLOYEE_SKILL_STATUS_IN_MEETING, {
    variables: { id: employeeId },
    fetchPolicy: 'network-only',
  })
}

export const useSkillStatusBlocksMeeting = (
  meetingId: string,
): QueryResult<SkillStatusBlocksMeetingQuery, SkillStatusBlocksMeetingQueryVariables> => {
  return useQuery<SkillStatusBlocksMeetingQuery, SkillStatusBlocksMeetingQueryVariables>(SKILL_STATUS_BLOCKS_MEETING, {
    variables: { meetingId },
    fetchPolicy: 'network-only',
  })
}
